import React from "react";
import type { PropsWithChildren } from "react";

import { inlineStack } from "./HorizontalProductCard.css";

export const HorizontalProductCardInlineStack: React.FC<PropsWithChildren> = ({
  children
}) => {
  return <div className={inlineStack}>{children}</div>;
};
